import { createToolbarButtons } from "../createToolbarButtons";
import { EditLinkButton } from "./EditLinkButton";
import { BreakLinkButton } from "./BreakLinkButton";
import { EditLinkBar } from "./EditLinkBar";
import { linkDecorator } from "./linkDecorator";
import { toggleLink } from "lib/helpers";
import { RichUtils } from "draft-js";


const defaultOptions = {
	buttons: ['link', 'unlink'],
}

const BUTTON_MAP = {
	link: EditLinkButton,
	unlink: BreakLinkButton,
}

/**
 * @returns {DraftEditorPlugin}
 */
export function createLinkPlugin(options = defaultOptions) {
	options = { ...defaultOptions, ...options };
	return {
		name: 'link',

		getToolbarButtons(props) {
			const editorState = props.store.getEditorState();
			// 代码块不支持超连接
			if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
				return null;
			}
			return createToolbarButtons(BUTTON_MAP, options.buttons, props);
		},

		getToolbarWidgets({ store }) {
			return [{
				key: 'link-bar',
				component: EditLinkBar,
				props: {
					onSave(url) {
						const { getEditorState, setEditorState } = store;
						toggleLink({ getEditorState, setEditorState, url });
					}
				}
			}];
		},

		getDraftDecorators() {
			return [linkDecorator];
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/linkPlugin/createLinkPlugin.js